export const Navbar = () => {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-[#FCF5EB]/90 backdrop-blur-md border-b border-[#B4A893]/25"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="/"
          className="font-serif-display text-lg md:text-2xl font-light tracking-wide text-[#02515A] whitespace-nowrap"
          data-testid="navbar-wordmark"
        >
          Goodbye <span className="italic">on Your Terms</span>
        </a>
        <nav className="flex items-center gap-8">
          <a
            href="/#experiences"
            className="hidden md:block text-xs tracking-[0.25em] uppercase text-[#8F8375] hover:text-[#02515A] transition-colors duration-300"
            data-testid="nav-experiences-link"
          >
            Experiences
          </a>
          <a
            href="/podcast"
            className="hidden md:block text-xs tracking-[0.25em] uppercase text-[#8F8375] hover:text-[#02515A] transition-colors duration-300"
            data-testid="nav-podcast-link"
          >
            Podcast
          </a>
          <a
            href="/#enquiry"
            className="text-[10px] md:text-xs tracking-[0.2em] md:tracking-[0.25em] uppercase border border-[#02515A] px-4 py-2.5 md:px-6 md:py-3 hover:bg-[#02515A] hover:text-[#FCF5EB] transition-colors duration-500 whitespace-nowrap"
            data-testid="nav-enquiry-link"
          >
            Begin a Conversation
          </a>
        </nav>
      </div>
    </header>
  );
};
